import React from 'react';
import Routes from '../../helpers/Routes';
import Request from '../../helpers/Request';
import './Navigation.css';
import { withRouter } from 'react-router-dom'
import TagNavigator from '../Tags/TagNavigator';
import AddRecipeButton from './AddRecipeButton';
import CookieWrapper from '../CookieWrapper/CookieWrapper';
import PageButtons from '../PageButtons/PageButtons';
import DeleteButton from '../Buttons/DeleteButton';
import ArchiveButton from '../Buttons/ArchiveButton';
import TagButton from '../Buttons/TagButton';
import BatchSheetNavPreview from '../Documents/BatchSheetNav/BatchSheetNavPreview';
import SendDocumentToButton from '../Buttons/SendDocumentToButton';
import Search from '../Search/Search';
import DocumentRecipeRow from '../Documents/DocumentRecipeRow';
import qs from 'qs';
import DocumentRecipePreview from '../Documents/DocumentRecipePreview';
import ActiveTagsNavigator from '../Tags/ActiveTagsNavigator';
import ExcludedTagsNavigator from '../Tags/ExcludedTagsNavigator';
import { Information } from '../Icons/IconLibrary';
import CreateTagButton from '../Buttons/CreateTagButton';
import { toast } from 'react-toastify';
import DocumentReportButton from './DocumentReport/DocumentReportButton';
import AdvancedSearchButton from './AdvancedSearchComponents/AdvancedSearchButton';
import Tutorial2Element from '../Layout/Help/Onboarding/Tutorial2Element';
import BatchSheetNavRow from '../Documents/BatchSheetNav/BatchSheetNavRow';
class Navigation extends React.Component {
  constructor(props) {
    super(props);
    this.onGetDocuments = this.onGetDocuments.bind(this);
    this.handleSearchRequest = this.handleSearchRequest.bind(this);
    this.onClearSelected = this.onClearSelected.bind(this);
    this.onLastSelected = this.onLastSelected.bind(this);
    this.onChangeTags = this.onChangeTags.bind(this);
    this.onChangePage = this.onChangePage.bind(this);
    this.tagNavigatorRef = React.createRef();
    this.searchStringGenerator = this.searchStringGenerator.bind(this);
    this.onGetNewTopTags = this.onGetNewTopTags.bind(this);
    this.onToggleDocPreview = this.onToggleDocPreview.bind(this);
    this.onCloseDocPreview = this.onCloseDocPreview.bind(this);
    this.replaceActiveDocuments = this.replaceActiveDocuments.bind(this);
    this.state = {
      docList: [],
      activeTags: [],
      excludedTags: [],
      activeDocuments: [],
      selectedDocument: null,
      showPreviewer: true,
      searchQuery: '',
      numResults: 0,
      status: 'Accepted',
      order_by: '',
      showBatchSheets: true,
      batchSheetList: [],
      selectedBatchSheets: [],
      numBatchSheetResults: 0,
    }
  }

  onSelectDocument = (doc) => {
    this.setState(prevState => {
      let activeDocuments = prevState.activeDocuments;
      let selectedDoc = prevState.selectedDocument;
      let activeDocumentsIds = (activeDocuments.map((entity) => { return entity.recipe.id }));

      if (
        activeDocumentsIds.indexOf(doc.recipe.id) > -1
      ) {
        activeDocuments = activeDocuments.filter(docs => docs.recipe.id !== doc.recipe.id);
      }
      else {
        activeDocuments = [...activeDocuments, doc];

      }
      if (prevState.selectedDocument !== doc) {
        selectedDoc = doc;
      }
      return { activeDocuments: activeDocuments, selectedDocument: selectedDoc };
    }
    );
  }
  onSelectBatchSheet = (doc) => {
    this.setState(prevState => {
      let activeDocuments = prevState.selectedBatchSheets;
      let selectedDoc = prevState.selectedDocument;
      let activeDocumentsIds = (activeDocuments.map((entity) => { return entity.batch_sheet_id }));

      if (
        activeDocumentsIds.indexOf(doc.batch_sheet_id) > -1
      ) {
        activeDocuments = activeDocuments.filter(docs => docs.batch_sheet_id !== doc.batch_sheet_id);
      }
      else {
        activeDocuments = [...activeDocuments, doc];

      }
      if (prevState.selectedDocument !== doc) {
        selectedDoc = doc;
      }
      return { selectedBatchSheets: activeDocuments, selectedDocument: selectedDoc };
    }
    );
  }
  orderDocsByRecency = () => {
    const searchString = qs.parse(this.props.location.search.substr(1));
    if (searchString.order_by === 'date_created_desc') {
      this.searchStringGenerator('date_created_asc', 'order_by');
    } else {
      this.searchStringGenerator('date_created_desc', 'order_by')
    }
  }
  orderDocsByName = () => {
    const searchString = qs.parse(this.props.location.search.substr(1));
    if (searchString.order_by === 'name_asc') {
      this.searchStringGenerator('name_desc', 'order_by');
    } else {
      this.searchStringGenerator('name_asc', 'order_by')
    }
  }
  orderDocsByDate = () => {
    const searchString = qs.parse(this.props.location.search.substr(1));
    if (searchString.order_by === 'date_expiration_desc') {
      this.searchStringGenerator('date_expiration_asc', 'order_by');
    } else {
      this.searchStringGenerator('date_expiration_desc', 'order_by')
    }
  }

  onClearSelected = () => {
    this.setState({ activeDocuments: [], selectedDocument: null, selectedBatchSheets: [] })
  }
  onSelectAll = () => {
    this.onClearSelected();
    this.setState({ activeDocuments: this.state.docList, selectedBatchSheets: this.state.batchSheetList })
  }
  toggleTagFilterSwitch = () => {

    this.searchStringGenerator('', 'filterSwitch');
  }
  componentDidMount() {
    this.onGetDocuments();
    this.onGetBatchSheets();
  }
  onBackButtonEvent = (e) => {
    e.preventDefault();
    this.props.history.goBack();
  }
  searchStringGenerator(input, type) {
    const searchString = qs.parse(this.props.location.search.substr(1));
    if (!searchString.page) {
      searchString.page = 1;
    }
    if (!searchString.per_page) {
      searchString.per_page = 20;
    }
    if (!searchString.status) {
      searchString.status = 'accepted';
    }
    if (searchString.q && searchString.q === '') {
      delete searchString.q;
    }
    switch (type) {
      case 'tags':
        if (input) {
          searchString.tag = input.join();
          searchString.page = 1;
        }
        else {
          delete searchString.tag
          searchString.page = 1;
        }
        break;
      case 'excludedTags':
        if (input) {
          searchString.exclude_tag = input.join();
          searchString.page = 1;
        }
        else {
          delete searchString.exclude_tag
          searchString.page = 1;
        }
        break;
      case 'pageSize':
        searchString.per_page = input;
        if (this.state.numResults / searchString.per_page < searchString.page) {
          searchString.page = Math.ceil(this.state.numResults / searchString.per_page);
        }
        break;
      case 'page':
        searchString.page = input;
        break;
      case 'search':
        searchString.q = input;
        searchString.page = 1;
        break;

      case 'order_by':
        searchString.order_by = input;
        break;

      case 'filterSwitch':
        if (searchString.filter_active_tags) {
          delete searchString.filter_active_tags;
        }
        else {
          searchString.filter_active_tags = true;
        }
        break;
      default:
    }

    let base_url = qs.stringify(searchString, { indices: false });
    this.onSearchStringChangeHelper('?' + base_url)
    return new Promise((resolve, reject) => {
      resolve(this.props.history.push({
        search: base_url,
        state: this.state,
      })
      )
    })
  }
  onCloseDocPreview() {
    this.setState({ showPreviewer: false })
  }
  onToggleDocPreview() {
    let active = !this.state.showPreviewer;
    this.setState({ showPreviewer: active });
  }
  onGetNewTopTags = () => {
    this.tagNavigatorRef.current.onGetTags();
  }
  onSearchStringChangeHelper = (searchString) => {
    Request.authRequest(Routes.recipes.index(searchString),
      'GET').then((response) => {
        if (response.status === 200) {
          response.json().then(body => {
            this.setState({
              docList: body.results,
              numResults: body.total_results,
              selectedDocument: null,
              activeDocuments: [],
            }

            )
            this.onGetBatchSheets();
          }
          )
        }
        else {
          response.json().then((error) => {
            toast.error(error.message);
          });
        }
      }).catch((error) => {
        toast.error(error.message);
      }
      )

  }

  // should be named on Get Recipes but afraid of breaking 5 bajillion imports.
  onGetDocuments = () => {
    Request.authRequest(Routes.recipes.index(this.props.location.search),
      'GET').then((response) => {
        if (response.status === 200) {
          response.json().then(body => {
            let newActiveDocuments = this.replaceActiveDocuments(body.results, this.state.activeDocuments);

            if (this.state.selectedDocument) {
              let docList = body.results.concat();
              let newSelectedDoc;
              if (this.state.selectedDocument.recipe) {
                newSelectedDoc = docList.filter(docs => docs.recipe.id === this.state.selectedDocument.recipe.id);
              }
              else if (this.state.selectedDocument.batch_sheet_id) {
                newSelectedDoc = docList.filter(docs => docs.batch_sheet_id === this.state.selectedDocument.batch_sheet_id);

              }
              if (newSelectedDoc === []) {
                newSelectedDoc = null;
              }
              this.setState({
                docList: body.results,
                numResults: body.total_results,
                selectedDocument: newSelectedDoc[0],
                activeDocuments: newActiveDocuments
              })
              return
            }
            this.setState({
              docList: body.results,
              numResults: body.total_results,
              activeDocuments: newActiveDocuments,
              docListLoaded: true
            })
          })
        }

        else {
          response.json().then((error) => {
            toast.error(error.message);
          });
        }
      }).catch((error) => {
        toast.error(error.message);
      }
      )
  }
  getRecipesAndBatchSheets = () => {
    this.onGetDocuments();
    this.onGetBatchSheets();
  }
  replaceActiveDocuments(documentList, activeList) {
    let newActiveDocuments = [];
    let documentListIDs = documentList.map((doc) => {
      return doc.recipe.id
    })
    for (let i = 0; i < activeList.length; i++) {
      let index = documentListIDs.indexOf(activeList[i].recipe.id);
      if (index > -1) {
        newActiveDocuments.push(documentList[index]);
      }
    }
    return newActiveDocuments;
  }
  replaceActiveBatchSheets(documentList, activeList) {
    let newActiveDocuments = [];
    let documentListIDs = documentList.map((doc) => {
      return doc.batch_sheet_id
    })
    for (let i = 0; i < activeList.length; i++) {
      let index = documentListIDs.indexOf(activeList[i].batch_sheet_id);
      if (index > -1) {
        newActiveDocuments.push(documentList[index]);
      }
    }
    return newActiveDocuments;
  }
  /* if the promise is rejected we need error handling*/
  changeShowBatchSheets = () => {
    this.setState({ showBatchSheets: !this.state.showBatchSheets }, () => this.onGetBatchSheets);
  }
  onGetBatchSheets = () => {
    if (this.state.showBatchSheets) {
      Request.authRequest(Routes.recipes.batchSheetList(this.props.location.search),
        'GET').then((response) => {
          if (response.status === 200) {
            response.json().then(body => {
              let newActiveDocuments = this.replaceActiveBatchSheets(body.results, this.state.selectedBatchSheets);

              if (this.state.selectedDocument) {
                let docList = body.results.concat();
                let newSelectedDoc = docList.filter(docs => docs.batch_sheet_id === this.state.selectedDocument.batch_sheet_id);

                if (newSelectedDoc === []) {
                  newSelectedDoc = null;
                }
                this.setState({
                  batchSheetList: body.results,
                  numBatchSheetResults: body.total_results,
                  selectedDocument: newSelectedDoc[0],
                  selectedBatchSheets: newActiveDocuments
                })
                return
              }
              this.setState({
                batchSheetList: body.results,
                numBatchSheetResults: body.total_results,
                selectedBatchSheets: newActiveDocuments,
                docListLoaded: true
              })
            })
          }
          else {
            response.json().then((error) => {
              toast.error(error.message);
            });
          }
        }).catch((error) => {
          toast.error(error.message);
        }
        )
    }
  }
  onChangeTags = (tags) => {
    this.searchStringGenerator(tags, 'tags');
  }
  onChangeExcludedTags = (tags) => {
    this.searchStringGenerator(tags, 'excludedTags');
  }
  onChangePage = (pageNumber) => {
    this.onClearSelected();
    this.searchStringGenerator(pageNumber, 'page');
  }
  handleSearchRequest = (updated_string) => {
    this.searchStringGenerator(updated_string, 'search');
  }

  onChangePageSize = (e) => {
    this.searchStringGenerator(e.target.value, 'pageSize');
  }
  onLastSelected() {
    /* this function is empty to reuse the navigator component between the tags page and the document page.*/
    return
  }
  onGetPinnedTags = () => {
    this.tagNavigatorRef.current.onGetPinnedTags();
  }
  render() {
    let documentRowList = <div className="loaderContainer"><div class="lds-ring"><div></div><div></div><div></div><div></div></div></div>
    if (this.state.docListLoaded) {
      documentRowList = <div className="helpText">No Recipes. Press Create to make a new recipe!</div>
    }
    let batchSheetList;
    if (this.state.docList.length > 0) {
      documentRowList = this.state.docList.map((entity, i) => {
        return <DocumentRecipeRow document={entity} key={i} onSelectDoc={this.onSelectDocument}
          activeDocuments={this.state.activeDocuments}
          onGetDocuments={this.onGetDocuments} />
      })
    }
    if (this.state.showBatchSheets && this.state.batchSheetList.length > 0) {
      batchSheetList = this.state.batchSheetList.map((entity, i) => {
        return <BatchSheetNavRow document={entity} key={i} onSelectDoc={this.onSelectBatchSheet}
          activeDocuments={this.state.selectedBatchSheets}
          onGetDocuments={this.onGetBatchSheets} />
      });
      if (this.state.docList.length == 0) {
        documentRowList = '';
      }
    }

    documentRowList = <div>{documentRowList} {batchSheetList}</div>
    let selectedDocument = this.state.selectedDocument;
    let activeDocuments = this.state.activeDocuments;
    let activeBatchSheets = this.state.selectedBatchSheets;
    const searchString = qs.parse(this.props.location.search.substr(1));
    let perPage = 20;
    let page = 1;
    let query;
    if (searchString.q) {
      query = searchString.q;
    }
    if (searchString.per_page) {
      perPage = searchString.per_page;
    }
    if (searchString.page) {
      page = searchString.page
    }
    let filter_active_tags = false;
    if (searchString.filter_active_tags) {
      filter_active_tags = true;
    }
    let tutorial;
    if (searchString.tutorial) {
      tutorial = <Tutorial2Element />;
    }
    let activeTags = [];
    let excludedTags = [];
    if (searchString.tag) {
      activeTags = searchString.tag.split(',');
      if (!Array.isArray(activeTags)) {
        activeTags = [activeTags]
      }
    }
    if (searchString.exclude_tag) {
      excludedTags = searchString.exclude_tag.split(',');
      if (!Array.isArray(excludedTags)) {
        excludedTags = [excludedTags]
      }

    }
    let organization_name;
    if (searchString.organization_name) {
      organization_name = searchString.organization_name;
    }
    let preview;
    if (this.state.showPreviewer) {

      preview = <DocumentRecipePreview doc={selectedDocument}
        onGetDocuments={this.onGetDocuments}
        onGetTags={this.onGetNewTopTags}
        onCloseDocPreview={this.onCloseDocPreview}
      />

      if (this.state.selectedDocument && this.state.selectedDocument.batch_sheet_id) {
        preview = <BatchSheetNavPreview doc={selectedDocument}
          onGetDocuments={this.onGetBatchSheets}
          onGetTags={this.onGetNewTopTags}
          onCloseDocPreview={this.onCloseDocPreview}
        />
      }
    }
    return (
      <div className="columns">
        <div className="left-documents">
          <div className="left-documents-tags boxShadow">
            <div className="left-documents-tags-header noselect">Tags Bank
              <CreateTagButton onGetTags={this.onGetNewTopTags} />
            </div>
            <TagNavigator onLastSelected={this.onLastSelected}
              onChangeTags={this.onChangeTags}
              onChangeExcludedTags={this.onChangeExcludedTags}
              activeTags={activeTags}
              excludedTags={excludedTags}
              toggleSwitch={this.toggleTagFilterSwitch}
              isFiltered={filter_active_tags}
              ref={this.tagNavigatorRef}
              showFilter={true}
            />
          </div>
          {tutorial}
        </div>
        <div className="middle-container">
          <div className="navigation-selectedTagsContainer">
            <ActiveTagsNavigator activeTags={activeTags} onChangeTags={this.onChangeTags}
              onLastSelected={this.onLastSelected}
              excludedTags={excludedTags}
              onChangeExcludedTags={this.onChangeExcludedTags}
              onGetPinnedTags={this.onGetPinnedTags} />
            <ExcludedTagsNavigator activeTags={activeTags}
              excludedTags={excludedTags}
              onChangeTags={this.onChangeTags}
              onChangeExcludedTags={this.onChangeExcludedTags}
              onLastSelected={this.onLastSelected}
              onGetPinnedTags={this.onGetPinnedTags} />
          </div>
          <div className="middle-documents boxShadow">
            <div className="middle-documentsTitle">
              <div>Recipes</div>
              <div className="documents-SearchContainer">
                <Search id='documentSearch' sendSearch={this.handleSearchRequest} placeholder="Search for a document"
                  query={query} />


              </div>
              <AddRecipeButton />
            </div>
            <div className="navigation-header">

              <button className="button-information" onClick={this.onToggleDocPreview}>
                <img className='buttonIcon' src={Information} alt='Toggle show document preview' title='Toggle show document preview' />
              </button>
              <TagButton
                docs={activeDocuments} onGetDocuments={this.getRecipesAndBatchSheets} activeBatchSheets={this.state.selectedBatchSheets}
                onGetTags={this.onGetNewTopTags} />



              <ArchiveButton
                docs={activeDocuments} onGetDocuments={this.getRecipesAndBatchSheets} activeBatchSheets={this.state.selectedBatchSheets} onGetTags />
              <DeleteButton
                items={activeDocuments} onGetDocuments={this.onGetDocuments} activeBatchSheets={this.state.selectedBatchSheets} onClear={this.onClearSelected}
                type="recipes" />


            </div>


            <div className="results-container">
              <div className="results-numResults">
                {this.state.numResults + this.state.numBatchSheetResults} total results
                {activeDocuments.length > 0 ?
                  <div className="selectedDocText">
                    - {activeDocuments.length + activeBatchSheets.length} Documents Selected
                    <button className="clearSelectedButton" onClick={this.onClearSelected}>Clear All</button>
                  </div>
                  :
                  <div className="selectedDocText" onClick={this.onSelectAll}>
                    - Select All
                  </div>
                }
              </div>
              <div className="resultsShown noselect">
                <div className="batchSheetIndicator">
                  <input type="checkbox" checked={this.state.showBatchSheets}
                    value={this.state.showBatchSheets} onClick={this.changeShowBatchSheets} />
                  <div>Show Batch Sheets</div></div>
                <select className="resultsShown-selector"
                  value={perPage}
                  onChange={this.onChangePageSize}>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select> Results Shown

              </div>
            </div>
            <div className="navigation-docs-table">
              <div className="navigation-docs-tableheader-name" >Recipe Name
              </div>
              <div className="navigation-docs-tableheader-expires" >Ingredients</div>
              <div className="navigation-docs-tableheader-tags">Tags</div>
            </div>
            <div className="documents">
              {documentRowList}
            </div>
            <PageButtons page={page} perPage={perPage}
              numResults={this.state.numResults} onChangePage={this.onChangePage} />

          </div>
        </div>
        <div className="right-documents">{preview}
        </div>


      </div>
    )
  };
}
export default withRouter(CookieWrapper(Navigation));
